import { File } from "@/type/core/dashboard/dashboard.types";
import { TransactionType } from "@/type/core/transaction/transaction.types";
import { FileHelper } from "@/utils/helpers/file-helper";
import FileInputLink from "@components/core/cards/FileInputLink";
import BasicLink from "@components/core/links/BasicLink";
import ChooseModelModal from "@components/core/modals/ChooseModelModal";
import FileIcon from "@static/core/icons/icon-file.svg?react";
import Dragger from "antd/lib/upload/Dragger";
import { FunctionComponent, useRef, useState } from "react";

interface ImportFilesCardProps {
  disabled?: boolean;
  title?: string;
  description: string;
  descriptionSeparator: string;
  descriptionUrlTitle: string;
  descriptionUrlTitle2?: string;
  url: string;
  accept: string;
  maxSize?: number;
  maxSizeOfAllFiles?: number;
  extensions?: string[];
  name: string;
  className?: string;
  setFiles: (files: File[]) => void;
  onClick?: () => void;
  openFilesSelectionOnClick?: boolean;
  transactionType?: TransactionType;
  currentDocumentsSize?: number;
  currentFileCount?: number;
  maxCount?: number;
}

const ImportFilesCard: FunctionComponent<ImportFilesCardProps> = ({
  disabled = false,
  title,
  description,
  descriptionSeparator,
  descriptionUrlTitle,
  descriptionUrlTitle2,
  url,
  accept,
  className = "",
  setFiles,
  extensions,
  maxSize,
  maxSizeOfAllFiles,
  onClick,
  openFilesSelectionOnClick = false,
  transactionType,
  currentDocumentsSize = 0,
  currentFileCount = 0,
  maxCount,
}) => {
  const inputFilesRef = useRef<HTMLInputElement>(null);
  const [isChooseModelModalOpen, setIsChooseModelModalOpen] =
    useState<boolean>(false);
  useState<{ key: string; [key: string]: any }[]>([]);

  return (
    <Dragger
      className={`app-card-import-files ${
        disabled ? "import-files-disabled" : ""
      } ${className}`}
      disabled={disabled}
      multiple
      onDrop={(event) => {
        event.preventDefault();
        FileHelper.handleFileInputChange(setFiles, {
          selectedFiles: event.dataTransfer.files,
          accept,
          currentDocumentsSize,
          currentFileCount,
          maxCount,
          extensions,
          maxSize,
          maxSizeOfAllFiles,
        });
      }}
      accept={accept}
      openFileDialogOnClick={false}
      showUploadList={false}
      beforeUpload={() => {
        // Prevent POST request from the component
        return false;
      }}
      maxCount={maxCount}
    >
      <div
        data-test={"card"}
        data-alt={title}
        className="card-import-files-container"
        onClick={() => {
          if (!disabled) {
            onClick?.();
            if (openFilesSelectionOnClick) {
              inputFilesRef.current?.click();
            }
          }
        }}
      >
        {title && (
          <h3
            className={`card-import-files-title ${
              disabled ? "cursor-auto" : "cursor-pointer"
            }`}
          >
            <FileIcon />
            <div
            // data-test={"card"}
            // data-alt={title}
            >
              <strong>{title}</strong>
            </div>
          </h3>
        )}
        <h3 className="card-import-files-title">{!title && <FileIcon />}</h3>
        <p onClick={(event) => event.stopPropagation()}>
          {description}
          <br />
          {descriptionSeparator}{" "}
          <FileInputLink
            inputFilesRef={inputFilesRef}
            accept={accept}
            descriptionUrlTitle={descriptionUrlTitle}
            url={url}
            disabled={disabled}
            setFiles={setFiles}
            extensions={extensions}
            maxSize={maxSize}
            maxSizeOfAllFiles={maxSizeOfAllFiles}
            currentDocumentsSize={currentDocumentsSize}
            maxCount={maxCount}
            currentFileCount={currentFileCount}
          >
            {descriptionUrlTitle}
          </FileInputLink>
          {descriptionUrlTitle2 && (
            <>
              <br />
              {descriptionSeparator}{" "}
              <BasicLink
                dataAlt={descriptionUrlTitle2}
                to={url}
                onClick={(event) => {
                  event.preventDefault();
                  if (!disabled) {
                    setIsChooseModelModalOpen(true);
                  }
                }}
                title={descriptionUrlTitle2}
                className="card-import-files-link"
              >
                {descriptionUrlTitle2}
              </BasicLink>
            </>
          )}
          <br />
        </p>
      </div>
      {descriptionUrlTitle2 && transactionType && (
        <ChooseModelModal
          visible={isChooseModelModalOpen}
          onCancel={() => setIsChooseModelModalOpen(false)}
          type={transactionType}
          url={url}
        />
      )}
    </Dragger>
  );
};

export default ImportFilesCard;
